import r from"chroma-js";export{default as alpha}from"color-alpha";var o=function(o,a){return r(o).darken(a).hex()},a=function(o,a){return r(o).brighten(a).hex()};export{a as brighten,o as darken};
